/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, lifecycle } from 'recompose'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { ROUTES } from 'constants/routes'
import { ERROR_CODES } from 'constants/errors'
import { ALERTS } from 'constants/alerts'
import { loading } from 'hocs/loading'
import { withLocalization } from 'hocs/localization'
import { confirmChangeEmail } from 'api/client/actions/auth'
import { onStartLogoutWithRedirect } from 'redux-app/actionCreators/auth'
import { createAlert, onShowError } from 'redux-app/modules/alerts'
import { isUserAuthorizated } from 'redux-app/selectors/auth'
import { getErrorCodes } from 'utils/error'
import { getQueryFromSearch } from 'utils/location'
import { LINK_STATUSES } from './contants'
import ConfirmChangeEmail from './ConfirmChangeEmail'

export default compose(
  connect(
    state => ({
      isUserAuthorizated: isUserAuthorizated(state),
    }),
    {
      confirmChangeEmail,
      createAlert,
      onShowError,
      onStartLogoutWithRedirect,
    },
  ),
  withRouter,
  lifecycle<any, any>({
    componentDidMount () {
      const {
        history: { replace },
        location: { search },
        confirmChangeEmail,
        isUserAuthorizated,
        createAlert,
        onStartLogoutWithRedirect,
      } = this.props
      const { token } = getQueryFromSearch(search)

      if (!token) {
        replace(ROUTES.home.logIn)
        return
      }

      confirmChangeEmail({
        token: decodeURIComponent(token),
      })
        .then(() => {
          createAlert({ name: ALERTS.successChangeEmailConfirmed })
          if (isUserAuthorizated) {
            onStartLogoutWithRedirect()
          } else {
            replace(ROUTES.home.logIn)
          }
        })
        .catch(error => {
          const errorCodes = getErrorCodes(error)
          if (errorCodes.includes(ERROR_CODES.linkExpired)) {
            this.setState({
              status: LINK_STATUSES.expired,
              loadProgress: 100,
            })
            return
          }
          if (errorCodes.includes(ERROR_CODES.linkUsed)) {
            this.setState({
              status: LINK_STATUSES.notActual,
              loadProgress: 100,
            })
            return
          }
          if (errorCodes.includes(ERROR_CODES.changeEmailLinkAlreadyUsed)) {
            this.setState({
              status: LINK_STATUSES.used,
              loadProgress: 100,
            })
            return
          }
          this.setState({
            loadProgress: 100,
            status: LINK_STATUSES.error,
          })
        })
    },
  }),
  loading,
  withLocalization('confirmChangeEmail'),
)(ConfirmChangeEmail)
